export function scrollToOptions(
  root = null,
  rootMargin = "0px",
  threshold = 0.1
) {
  return {
    root,
    rootMargin,
    threshold,
  };
}
export function scrollObserver(callback, scrollOptions) {
  return new IntersectionObserver(callback, scrollOptions);
}
